import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "message-body-container" }
const _hoisted_2 = { class: "message-contents-field" }
const _hoisted_3 = {
  key: 0,
  class: "is-size-7"
}
const _hoisted_4 = {
  key: 1,
  class: "invoice-cost-container"
}
const _hoisted_5 = { class: "invoice-button-container" }
const _hoisted_6 = {
  key: 0,
  class: "invoice-cost-title"
}
const _hoisted_7 = {
  key: 1,
  class: "invoice-totals-table"
}
const _hoisted_8 = {
  key: 2,
  class: "invoice-cost-title"
}
const _hoisted_9 = {
  key: 3,
  class: "invoice-totals-table"
}
const _hoisted_10 = {
  key: 4,
  class: "invoice-subtotal"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, "Subtotal", -1)
const _hoisted_12 = {
  key: 3,
  class: "notification is-warning footer"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " Requester email not available - posts to timeline only. The requester will only be able to see your message if they contact your agency to have their email associated with this request. ", -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrFormLabel = _resolveComponent("NrFormLabel")!
  const _component_NrEditor = _resolveComponent("NrEditor")!
  const _component_NrIcon = _resolveComponent("NrIcon")!
  const _component_NrButton = _resolveComponent("NrButton")!
  const _component_LineItemsTable = _resolveComponent("LineItemsTable")!
  const _component_StaffHoursTable = _resolveComponent("StaffHoursTable")!
  const _component_SurchargesList = _resolveComponent("SurchargesList")!
  const _component_NrFormInput = _resolveComponent("NrFormInput")!
  const _component_MessageBox = _resolveComponent("MessageBox")!
  const _component_InvoiceAddItemModal = _resolveComponent("InvoiceAddItemModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($options.displayInvoiceBox)
      ? (_openBlock(), _createBlock(_component_MessageBox, {
          key: 0,
          title: "New invoice",
          "submit-text": "Send invoice",
          type: "green",
          disableSubmit: $options.disableSubmit,
          submitTooltipText: $options.tooltipText,
          onOnClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setDisplayCreateInvoiceMsgBox(false))),
          onOnCancel: $options.handleCancelInvoice,
          onOnSubmit: $options.handleSubmitInvoice
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_NrSelect, {
                  modelValue: $data.selectedInvoiceTemplate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedInvoiceTemplate) = $event)),
                  options: $data.templates,
                  onInput: $options.setMessageTemplate,
                  onSearch: $options.filterInvoiceTemplates,
                  placeholder: "Select invoice template",
                  multiple: ""
                }, {
                  label: _withCtx(() => [
                    _createTextVNode("Invoice Template")
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "onInput", "onSearch"]),
                _createVNode(_component_NrFormLabel, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Message contents")
                  ]),
                  _: 1
                }),
                _createVNode(_component_NrEditor, {
                  modelValue: $data.message,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.message) = $event)),
                  resizable: false,
                  placeholder: 'Type your message here or select a template above.',
                  rows: $options.rows,
                  strike: "",
                  bulletList: "",
                  orderedList: "",
                  link: ""
                }, null, 8, ["modelValue", "placeholder", "rows"]),
                ($options.requesterEmailAvailable)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, " This message will be visible to the requester and staff. "))
                  : _createCommentVNode("", true),
                (_ctx.account.invoicing_feature_flag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_NrButton, {
                          variant: "bordered-primary",
                          onClick: $options.openAddItemModal
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_NrIcon, {
                              class: "inline-icon",
                              name: "plus"
                            }),
                            _createTextVNode(" Add item ")
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_NrButton, {
                          variant: "bordered-primary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActiveModal('clock')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_NrIcon, {
                              class: "inline-icon",
                              name: "clock"
                            }),
                            _createTextVNode(" Add staff hours ")
                          ]),
                          _: 1
                        })
                      ]),
                      (_ctx.totalSelectedLineItems.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Line item "))
                        : _createCommentVNode("", true),
                      (_ctx.totalSelectedLineItems.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_LineItemsTable)
                          ]))
                        : _createCommentVNode("", true),
                      (Object.values(_ctx.requestStaffHours).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Staff hours "))
                        : _createCommentVNode("", true),
                      (Object.values(_ctx.requestStaffHours).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_StaffHoursTable)
                          ]))
                        : _createCommentVNode("", true),
                      (
              _ctx.totalSelectedLineItems.length > 0 ||
              Object.values(_ctx.requestStaffHours).length > 0
            )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("div", null, _toDisplayString($options.formatCost(_ctx.subtotalInvoiceAmount)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_SurchargesList)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.account.invoicing_feature_flag)
                  ? (_openBlock(), _createBlock(_component_NrFormInput, {
                      key: 2,
                      label: "Invoice amount",
                      placeholder: "Input dollar amount",
                      type: "number",
                      required: "",
                      modelValue: $data.totalAmount,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.totalAmount) = $event))
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (!$options.requesterEmailAvailable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.account.invoicing_feature_flag)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([
        'invoice-total-amount',
        $options.negativeInvoiceAmount ? 'negative-total-amount' : ''
      ])
                }, [
                  _createElementVNode("div", null, "Total: " + _toDisplayString($options.formatCost($options.roundedTotalInvoiceAmount)), 1)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["disableSubmit", "submitTooltipText", "onOnCancel", "onOnSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_InvoiceAddItemModal)
  ], 64))
}